import script from "./a-employee.vue?vue&type=script&setup=true&lang=ts"
export * from "./a-employee.vue?vue&type=script&setup=true&lang=ts"

import "./a-employee.vue?vue&type=style&index=0&id=f79dcc74&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f79dcc74"]])

export default __exports__